module.exports = __webpack_public_path__ + "img/director-test-icon4.ef453c33.png";